module.exports = __webpack_public_path__ + "static/media/atomizer-2.cfd72958.jpg";